export default __webpack_public_path__ + "static/media/edit-icon.7509e6fc.svg";